export const organisationIntegrationsQueryKey = 'listOrganisationIntegrations'
